import React, { MouseEvent, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {OrderFields} from "../types/fields";
import OrderStatusChip from "./OrderStatusChip";
import {OrderOption} from "../types/dto";
import Icon from "../../../@core/components/icon";
import {ListItemIcon} from "@mui/material";
import {getOrderStatusColor} from "../types/typification";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


interface OrderStatusChipWithMenuProps {
    orderOption: OrderOption;
    orderOptionList: OrderOption[];
    onOptionChange: (option: OrderOption) => void;
}

const OrderStatusChipWithMenu: React.FC<OrderStatusChipWithMenuProps> = ({ orderOption, orderOptionList, onOptionChange, ...rest }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedOption, setSelectedOption] = useState<OrderOption>(orderOption);


    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = async (option: OrderOption) => {
        await onOptionChange(option);
        setSelectedOption(option);
        setAnchorEl(null);
    };

    return (
        <div>
            <OrderStatusChip
                orderOption={selectedOption}
                onClick={handleClick}
                icon={<ArrowDropDownIcon />}
                elevation={3}
                {...rest}
            />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                {orderOptionList.map((option: OrderOption) => (
                    <MenuItem
                        key={option[OrderFields.StatusCode]}
                        selected={option[OrderFields.StatusCode] === selectedOption[OrderFields.StatusCode]}
                        onClick={() => handleMenuItemClick(option)}
                    >
                        <ListItemIcon>
                            <Icon
                                icon='mdi:circle'
                                color={getOrderStatusColor(option[OrderFields.StatusCode])}
                                fontSize='1rem'
                            />
                        </ListItemIcon>
                        {option[OrderFields.StatusDesc]}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default OrderStatusChipWithMenu;